import { useEffect, useRef } from 'react';
/**
 * Returns a boolean indicating if the component is in the first render (AKA mounting).
 */
var useIsMount = function () {
    var isMountRef = useRef(true);
    useEffect(function () {
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};
export default useIsMount;
//# sourceMappingURL=useIsMount.js.map